
/**
 * Constrains a particle's movement by locking a given axis to a fixed value.
 */
var	AxisConstraint = function(axis,constraintAmount){
	this.axis = axis;
	this.constraint = constraintAmount;
};

AxisConstraint.prototype.applyConstraint = function(p){
	p.setComponent(this.axis,this.constraint);
};

module.exports = AxisConstraint;




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/physics2d/constraints/AxisConstraint.js
// module id = 4644
// module chunks = 15